<template>
    <GoogleMap
        :center="center"
        :zoom="initialZoom"
        :minZoom="17"
        :options="{ mapOptions }"
        :style="{ height: height + 'px' }"
        :class="mapClasses"
        class="relative js-map"
        v-on:bounds_changed="getDrainsOnMove"
        v-on:zoom_changed="zoomChangedEmitter"
        :api-key="apiKey"
        ref="mapRef"
    >
        <GoogleMapMarker
            v-for="drain in drains"
            :key="drain.id"
            :drain="drain"
            :position="getPosition(drain)"
            :my-drain-ids="myDrainIds"
            :adopted-drain-ids="adoptedDrainIds"
            :opened-drain-id="openedDrain"
            @drainOpened="(drainId) => openedDrain = drainId"
        ></GoogleMapMarker>

        <div slot="visible">
            <div
                class="absolute z-40 flex items-center px-5 py-2 bg-white text-md"
                style="top: 10px; right: 60px; box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;"
            >
                <div v-if="this.user != null" class="flex items-center">
                    <img src="/images/map-pin-purple.png" class="w-4 mr-1" />
                    <p class="pt-1 mr-2">My Drain</p>
                </div>

                <img src="/images/map-pin-blue.png" class="w-4 mr-1" />
                <p class="pt-1 mr-2">Adopted Drain</p>

                <img src="/images/map-pin-yellow.png" class="w-4 mr-1" />
                <p class="pt-1">Un-Adopted Drain</p>
            </div>

            <div
                class="absolute z-40 p-4 text-lg font-bold text-center bg-white border border-grey-dark"
                style="bottom: 10px; left: 50%; margin-left: -125px; box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px; width: 250px;"
                v-show="this.drains.length == 0 || this.loading"
            >
                <span v-show="this.loading">
                    Loading...
                </span>

                <span v-show="this.drains.length == 0 && !this.loading">
                    No drains found.
                </span>
            </div>
        </div>
    </GoogleMap>
</template>

<script>
import { GoogleMap } from "vue3-google-map";
import GoogleMapMarker from './GoogleMapMarker';

export default {
    components: {
        GoogleMap, GoogleMapMarker
    },

    props: {
        adoptedDrainIds: { default: null },
        height: { default: null },
        mapClasses: { default: '' },
        initialZoom: { default: 17 },
        initialCenter: {},
        initialSelectedDrain: { default: null },
        myDrainIds: { default: null },
        user: { default: null },
    },

    data() {
        return {
            drains: [],
            loading: true,
            center: this.initialCenter,
            openedDrain: null,
            selectedDrain: this.initialSelectedDrain,
            displayInfoPopup: false,
            mapOptions: {
                minZoom: 17,
                maxZoom: 20,
                styles: [
                    {
                        featureType: 'poi.business',
                        stylers: [{ visibility: 'off' }],
                    },
                ],
            },
        };
    },

    computed: {
        apiKey() {
            return window.App.gmapsKey;
        },
    },

    mounted() {
        this.geolocate();

        if (this.initialSelectedDrain) {
            this.center = this.getPosition(this.initialSelectedDrain);
        }
    },

    methods: {
        geolocate() {
            navigator.geolocation.getCurrentPosition(position => {
                this.center = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
            });
        },

        getPosition(drain) {
            return { lat: drain.latitude, lng: drain.longitude };
        },
        setPlace(place) {
            this.center = place.geometry.location;
        },
        setSelectedDrain(drain) {
            this.selectedDrain = drain;
            this.displayInfoPopup = true;
        },
        generateQueryString(object) {
            var str = [];

            for (var item in object) {
                if (object.hasOwnProperty(item)) {
                    str.push(
                        encodeURIComponent(item) +
                            '=' +
                            encodeURIComponent(object[item])
                    );
                }
            }

            return str.join('&');
        },
        getDrainsOnMove() {
            this.loading = true;
            this.getDrainsOnMoveDebounced(this.$refs.mapRef.map.getBounds());
        },
        getDrainsOnMoveDebounced: _.debounce(function(bounds) {
            if (!bounds) return;

            let data = {
                top: bounds.getNorthEast().lat(),
                bottom: bounds.getSouthWest().lat(),
                left: bounds.getSouthWest().lng(),
                right: bounds.getNorthEast().lng(),
            };

            this.$emit('update:center', {
                lat: bounds.getCenter().lat(),
                lng: bounds.getCenter().lng(),
            });

            window.axios
                .request({
                    url:
                        '/internal-api/drains/?' +
                        this.generateQueryString(data),
                    method: 'get',
                })
                .then(
                    response => {
                        this.drains = response.data.data;
                        this.loading = false;
                    },
                    response => {
                        console.log(response);
                    }
                );
        }, 500),
        zoomChangedEmitter(zoomLevel) {
            this.$emit('update:zoom', zoomLevel);
        },
    },

    watch: {
        initialCenter(coordinates) {
            this.center = coordinates;
        },
    },
};
</script>
